export const modeSelectorContainerSx = ({ palette }) => ({
  display: 'flex',
  alignSelf: 'flex-start',
  padding: 0.25,
  borderRadius: 1,
  backgroundColor: palette.background.secondary,
});

export const getModeButtonSx =
  isActive =>
  ({ palette, shadows }) => ({
    minWidth: 0,
    paddingX: 1.5,
    paddingY: 0.5,
    borderRadius: 0.75,
    color: isActive ? palette.text.primary : palette.text.secondary,
    backgroundColor: isActive ? palette.background.paper : 'transparent',
    boxShadow: isActive ? shadows[1] : 'none',
    transition: 'background-color 120ms, color 120ms',
    '&:hover': {
      backgroundColor: isActive ? palette.background.paper : palette.action.hover,
    },
  });
